module.exports = __webpack_public_path__ + "img/logo.3dd19544.png";